<template>
    <div class="panel__list__item">
        <h3 class="purple">{{item.name}}</h3>
        <div><b><i>{{item.company}}</i></b></div>
        <span>{{item.description}}</span>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    @Component
    export default class ReferenceItem extends Vue {
        name = 'reference-item';

        @Prop()
        item;

    }

</script>



// WEBPACK FOOTER //
// src/components/panels/profile/ReferenceItem.vue